export enum FILTER_PANEL_UPDATE_TYPES {
  SUBMIT,
  UPDATE,
  CANCEL,
}
